import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Screen1Hero } from './components/teaser/Screen1Hero';
import { Screen3Ranking } from './components/teaser/Screen3Ranking';
import { Screen5Memory } from './components/teaser/Screen5Memory';
import { Screen6Video } from './components/teaser/Screen6Video';
import { Screen7Input } from './components/teaser/Screen7Input';
import { PostScreen1Recap } from './components/postEra/PostScreen1Recap';
import { PostScreen2Callback } from './components/postEra/PostScreen2Callback';
import { PostScreen3Highlights } from './components/postEra/PostScreen3Highlights';
import { PostScreen4Requested } from './components/postEra/PostScreen4Requested';
import { PostScreen5Reactions } from './components/postEra/PostScreen5Reactions';
import { PostScreenPollHighlight } from './components/postEra/PostScreenPollHighlight';
import { PostScreenPollFuture } from './components/postEra/PostScreenPollFuture';
import { PostScreen6Closing } from './components/postEra/PostScreen6Closing';
type FlowType = 'pre' | 'post';
export function App() {
  const [flow, setFlow] = useState<FlowType>('pre');
  const [screen, setScreen] = useState(0);
  const next = () => setScreen(s => Math.min(s + 1, flow === 'pre' ? 4 : 7));
  const restart = () => setScreen(0);
  const switchFlow = (newFlow: FlowType) => {
    setFlow(newFlow);
    setScreen(0);
  };
  const preScreens = [<Screen1Hero key="1" onNext={next} data-id="element-0" />, <Screen3Ranking key="3" onNext={next} data-id="element-1" />, <Screen5Memory key="5" onNext={next} data-id="element-2" />, <Screen6Video key="6" onNext={next} data-id="element-3" />, <Screen7Input key="7" onRestart={restart} data-id="element-4" />];
  const postScreens = [<PostScreen1Recap key="p1" onNext={next} data-id="element-5" />, <PostScreen2Callback key="p2" onNext={next} data-id="element-6" />, <PostScreen3Highlights key="p3" onNext={next} data-id="element-7" />, <PostScreen4Requested key="p4" onNext={next} data-id="element-8" />, <PostScreen5Reactions key="p5" onNext={next} data-id="element-9" />, <PostScreenPollHighlight key="p6" onNext={next} data-id="element-10" />, <PostScreenPollFuture key="p7" onNext={next} data-id="element-11" />, <PostScreen6Closing key="p8" onRestart={restart} data-id="element-12" />];
  const screens = flow === 'pre' ? preScreens : postScreens;
  return <div className="min-h-screen w-full bg-black flex flex-col items-center justify-center p-4 gap-4" data-id="element-13">
      {/* Flow selector buttons */}
      <div className="flex gap-3 z-30" data-id="element-14">
        <button onClick={() => switchFlow('pre')} className={`px-6 py-2.5 rounded-full text-sm font-semibold tracking-wide uppercase transition-all ${flow === 'pre' ? 'bg-red-600 text-white shadow-[0_8px_30px_rgba(220,38,38,0.4)]' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`} data-id="element-15">
          Pre-ERA Snak
        </button>
        <button onClick={() => switchFlow('post')} className={`px-6 py-2.5 rounded-full text-sm font-semibold tracking-wide uppercase transition-all ${flow === 'post' ? 'bg-green-600 text-white shadow-[0_8px_30px_rgba(34,197,94,0.4)]' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`} data-id="element-16">
          Post-ERA Snak
        </button>
      </div>

      <div className="relative overflow-hidden bg-slate-950 w-full h-screen sm:h-[760px] sm:w-[380px] sm:rounded-[2.4rem] sm:shadow-[0_30px_80px_rgba(0,0,0,0.6),0_0_60px_rgba(220,38,38,0.15)]" data-id="element-17">
        {/* Status bar */}
        <div className="absolute top-0 inset-x-0 z-20 h-8 px-6 flex items-center justify-between text-[10px] text-white/90 font-medium pointer-events-none" data-id="element-18">
          <span data-id="element-19">9:41</span>
          <div className="flex items-center space-x-1" data-id="element-20">
            <span data-id="element-21">●●●</span>
            <span data-id="element-22">5G</span>
            <span data-id="element-23">100%</span>
          </div>
        </div>

        {/* Progress dots */}
        <div className="absolute top-10 left-0 right-0 z-20 flex justify-center space-x-1 px-8 pointer-events-none" data-id="element-24">
          {screens.map((_, i) => <div key={i} className={`h-0.5 flex-1 rounded-full transition-all duration-500 ${i <= screen ? flow === 'pre' ? 'bg-red-500' : 'bg-green-500' : 'bg-white/15'}`} data-id="element-25" />)}
        </div>

        {/* Screens */}
        <AnimatePresence mode="wait" data-id="element-26">
          <motion.div key={`${flow}-${screen}`} initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="absolute inset-0" data-id="element-27">
            {screens[screen]}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}